<div class="sch-pay-top">
    <div class="sch-pay-top-header">
        <div class="schedule-pay-header-section">
            <div class="sch-pay-title">{{"schedulepay.title" | cxTranslate}}</div>
            <div class="schPay_Right_Border"></div>
            <div class="sch-pay-count">{{schPayCount}}</div>
        </div>
        <div class="sch-pay-link-section">
            <div class="sch-pay-link"><span >{{"schedulepay.gobacktxt" | cxTranslate}} </span><span class="all_inv_link"><a routerLink="/financial-dashboard/all-invoices">{{"schedulepay.allinvoicetxt" | cxTranslate}}</a></span></div>
        </div>
    </div>
</div> 

